import { render, staticRenderFns } from "./LoginStudent.vue?vue&type=template&id=02ea1366&scoped=true"
import script from "./LoginStudent.vue?vue&type=script&lang=js"
export * from "./LoginStudent.vue?vue&type=script&lang=js"
import style0 from "./LoginStudent.vue?vue&type=style&index=0&id=02ea1366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea1366",
  null
  
)

export default component.exports